import { HeaderNavLink as e } from "../base/HeaderLink.js";
import { getAriaProps as t, getLevelState as n, handleMouseEnter as r, handleMouseLeave as i, isCyoItem as a } from "../navState.js";
import { DesktopCyoMenu as o } from "./DesktopCyoMenu.js";
import { DesktopNavLevel3 as s } from "./DesktopNavLevel3.js";
import { useNavigationScroll as c } from "./useNavigationScroll.js";
import { Button as l, Chevron as u } from "@sprd/sprd-component-kit/v2";
import d from "clsx";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/Header/desktop/DesktopNavLevel2.tsx
function m({ items: e, currentLevelState: t, nextLevelStates: n, setLevelStates: r, mouseLeaveTimeout: i, linkComponent: o, openMenuLabel: s }) {
	let { listRef: m, isOverflowing: g, isAtEnd: _, scrollHandler: v } = c(), y = e.filter((e) => !a(e)), b = e.filter(a), x = {
		nextLevelStates: n,
		setLevelStates: r,
		mouseLeaveTimeout: i,
		linkComponent: o,
		openMenuLabel: s
	};
	return /* @__PURE__ */ p("div", {
		className: d("absolute", t.isShown ? "visible" : "invisible", "before-white top-full left-0 flex min-h-15 w-full items-center justify-between gap-2 bg-white py-2"),
		children: [
			/* @__PURE__ */ p("div", {
				className: d(t.isShown && g && _ ? "visible" : "invisible", "absolute left-0 z-2"),
				children: [/* @__PURE__ */ f("div", { className: "absolute left-0 z-1 h-full w-20 bg-linear-to-r from-white via-white/90 to-transparent" }), /* @__PURE__ */ f(l, {
					variant: "plain",
					onClick: () => v("left"),
					className: "px-0!",
					children: /* @__PURE__ */ f(u, { className: "relative z-2 size-6 rotate-90" })
				})]
			}),
			/* @__PURE__ */ f("ul", {
				ref: m,
				className: "before-white flex min-w-0 shrink grow items-center gap-5 overflow-x-auto no-scrollbar",
				children: y.map((e) => /* @__PURE__ */ f(h, {
					item: e,
					...x
				}, e.key))
			}),
			/* @__PURE__ */ p("div", {
				className: d(t.isShown && g && !_ ? "visible" : "invisible", "relative"),
				children: [/* @__PURE__ */ f("div", { className: "absolute right-0 z-1 h-full w-20 bg-linear-to-l from-white via-white/90 to-transparent" }), /* @__PURE__ */ f(l, {
					variant: "plain",
					onClick: () => v("right"),
					className: "px-0!",
					children: /* @__PURE__ */ f(u, { className: "relative z-2 size-6 -rotate-90" })
				})]
			}),
			b.map((e) => /* @__PURE__ */ f(h, {
				item: e,
				asList: !1,
				...x
			}, e.key))
		]
	});
}
function h({ item: c, nextLevelStates: l, setLevelStates: u, mouseLeaveTimeout: m, linkComponent: h, openMenuLabel: g, asList: _ = !0 }) {
	let v = n(l, c.key);
	if (!v) return null;
	let y = _ ? "li" : "div", b = t(v, c.label, g), x = v.isShown || v.isActive, S = () => r(m, u, v), C = () => i(m, u, v);
	return /* @__PURE__ */ f(y, {
		className: "flex h-full items-center whitespace-nowrap",
		onMouseEnter: S,
		onMouseLeave: C,
		onFocus: (e) => {
			e.stopPropagation(), S();
		},
		onBlur: C,
		tabIndex: 0,
		children: a(c) ? /* @__PURE__ */ f(o, {
			item: c,
			isShown: v.isShown,
			linkComponent: h
		}) : /* @__PURE__ */ p("div", { children: [c.link ? /* @__PURE__ */ f(e, {
			isActive: x,
			link: c.link,
			linkComponent: h,
			...b,
			children: c.label
		}) : /* @__PURE__ */ f("span", {
			className: d(x ? "underline" : "", "cursor-default decoration-2 underline-offset-4"),
			...b,
			children: c.label
		}), c.columns && c.columns.length > 0 ? /* @__PURE__ */ f(s, {
			columns: c.columns,
			isShown: v.isShown,
			teaser: c.teaser,
			linkComponent: h
		}) : null] })
	});
}
//#endregion
export { m as DesktopNavLevel2 };
